import { SalvTable, SalvTextField, Size } from '@salvapp/ui-components';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import { InternalApiEntityGroup } from '../../../api-internal';
import useSegmentColumns from '../../configure/segments/useSegmentColumns';

interface Props {
  segments: InternalApiEntityGroup[];
  isLoading: boolean;
  selectedSegments: InternalApiEntityGroup[];
  setSelectedSegments: (segments: InternalApiEntityGroup[]) => void;
  disabledCodes: string[];
}

export const SegmentsTable = ({ segments, isLoading, selectedSegments, setSelectedSegments, disabledCodes }: Props) => {
  const [filter, setFilter] = useState<string>();
  const [filteredSegments, setFilteredSegments] = useState<InternalApiEntityGroup[]>();

  useEffect(() => {
    setFilteredSegments(
      (segments ?? []).filter((segment) => segment.name.toLowerCase().includes(filter?.toLowerCase() ?? ''))
    );
  }, [filter, segments]);

  const columns = useSegmentColumns();

  return (
    <>
      <div className='m-t-16'>
        <SalvTextField
          ariaLabel='Search Segment'
          className='m-b-16'
          placeholder='Search by name...'
          icon={faMagnifyingGlass}
          onChange={setFilter}
        />
        <SalvTable
          className='segment-table'
          size={Size.SMALL}
          data={filteredSegments ?? []}
          columns={columns}
          isLoading={isLoading}
          selectedRows={selectedSegments}
          setSelectedRows={setSelectedSegments}
          emptyMessage='No Segments found'
          allowSelectAll={false}
          hover={true}
          isRowSelectionEnabled={(row) => !disabledCodes.includes(row.original.code!)}
        />
      </div>
    </>
  );
};
